import { render, staticRenderFns } from "./FnfLeagueTables.vue?vue&type=template&id=6cd06fce&"
import script from "./FnfLeagueTables.vue?vue&type=script&lang=js&"
export * from "./FnfLeagueTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports